import React, { useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { useTranslation } from 'react-i18next';

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginImageValidateSize,
);

/**
 *
 * @param {*} props
 * @returns {드롭존 이미지 등록}
 */
const DropZoneImage = (props) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState(null);
  const { height, width, setFile } = props;

  /** 이미지 사이즈 유효성 */
  const imageSizeValidation = (files) => {
    // console.log('valie');
    // console.log(files);
  };

  /** 업로드할 이미지 파일 보내기 */
  const onupdatefiles = (fileData) => {
    if (fileData.length === 0) {
      return;
    } else {
      setFile(fileData[0].file);
    }
  };

  return (
    <FilePond
      className='dropzone'
      allowImageValidateSize={false}
      imageValidateSizeMinWidth={width}
      imageValidateSizeMaxWidth={width}
      imageValidateSizeMinHeight={height}
      imageValidateSizeMaxHeight={height}
      allowFileTypeValidation={true}
      acceptedFileTypes={['image/jpg', 'image/jpeg', 'image/png']}
      file={files}
      multiple={false}
      allowMultiple={false}
      onupdatefiles={onupdatefiles}
      allowImagePreview={true}
      labelIdle={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.registerBackgroundModal.dragAndDrop',
      )}
    />
  );
};

export default DropZoneImage;
